import { useState, useEffect } from "react";
import { Alert, AlertTitle, Avatar, CardHeader } from "@mui/material";
import { getAportes } from "../componentes/api.js";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import Card1 from "@mui/material/Card";
import Card from "react-bootstrap/Card";
import { RUTA_IMG, RUTA_SERVER } from "../componentes/config.js";
import ReactPlayer from "react-player";

const Proyecto = (props) => {
  //console.log(props)
  const [aportantes, setAportantes] = useState([]);
  const [datos, setDatos] = useState({
    Id: props.perfil.IdProyecto,
    Nbre: props.perfil.NbreProyecto,
    TipoProyecto: props.perfil.TipoProyecto,
    FechaIni: props.perfil.FechaIni,
    FechaFin: props.perfil.FechaFin,
    ObjetivoGral: props.perfil.ObjetivoGral,
    ObjetivoEspecifico: props.perfil.ObjetivoEspecifico,
    Presentacion: props.perfil.Presentacion,
  });

  /** Para muestra apreliminar de videos */
  const [video, setVideo] = useState("");

  useEffect(() => {
    cargarAportantes(props.perfil.IdProyecto);
    if (props.perfil.Presentacion !== "") {
      setVideo(
        RUTA_IMG + "proyectos/presentacion/" + props.perfil.Presentacion
      );
    }
  }, [props.perfil.IdProyecto]);

  const cargarAportantes = async (idProyecto) => {
    try {
      const response = await getAportes(idProyecto);
      setAportantes(response.data);
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al cargar la Información de los Aportantes",
        error,
      ]);
    }
  };

  return (
    <div className="container-fluid mt-3">
      {datos.toString().length > 0 && (
        <div className="row card shadow">
          <Alert severity="success">
            <AlertTitle>
              PROYECTO: <strong>{datos.Nbre}</strong>
            </AlertTitle>
          </Alert>

          <div className="row mx-0 mt-3">
            <Card>
              <Card.Body>
                <Card.Title>{datos.Nbre}</Card.Title>
                <Card.Subtitle className="mb-2 text-muted">
                  {datos.TipoProyecto}
                </Card.Subtitle>
                <Card.Subtitle className="mb-2 text-muted mb-3 mt-3">
                  <CalendarMonthIcon /> Periodo de ejecución del{" "}
                  {datos.FechaIni.substring(0, 10)} hasta el{" "}
                  {datos.FechaFin.substring(0, 10)}
                </Card.Subtitle>
              </Card.Body>

              <blockquote className="blockquote mb-3">
                <p>
                  {" "}
                  <EmojiObjectsIcon /> OBJETIVO GENERAL.{" "}
                </p>
                <footer className="blockquote-footer">
                  <cite title="Objetivo General">{datos.ObjetivoGral}</cite>
                </footer>
              </blockquote>
            </Card>
          </div>

          <div className="row mt-3 mb-3">
            <Alert severity="success">
              <AlertTitle>
                <strong>ENTIDADES APORTANTES</strong>
              </AlertTitle>
            </Alert>

            <div className="mt-3">
              {aportantes.map((reg, index) => {
                return (
                  <Card1 sx={{ marginBottom: 3 }} key={index}>
                    <CardHeader
                      avatar={
                        <Avatar src={RUTA_SERVER + "/" + reg.Logo || null} />
                      }
                      title={reg.NbreAportante}
                    />
                  </Card1>
                );
              })}
            </div>
          </div>

          <div className="row mt-3 mb-3">
            <Alert severity="success">
              <AlertTitle>
                <strong>VIDEO DE PRESENTACION</strong>
              </AlertTitle>
            </Alert>

            <div className="mt-3 mb-3 text-center">
              <div className="player-wrapper">
                <ReactPlayer
                  className="react-player"
                  url={video}
                  width="100%"
                  height="100%"
                  controls={true}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Proyecto;
